import useElement from "backend/hooks/elements/useElement";
import useFlatHierarchy from "backend/hooks/elements/useFlatHierarchy";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import { InitiativeCard } from "design/components/cards/InitiativeCard";
import KPIGridArea from "design/components/grids/MeasureGridArea";
import { InitiativesHeader } from "design/components/texts/Headers";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";

const Initiatives = () => {
  const ctx = useAppContext();
  const { data: root } = useScorecardTopElement("L0");

  const link = useLink();
  const { data, isLoading, isPreviousData, isRefetching } = useFlatHierarchy(
    ctx.elementId || root?.id
  );
  const { data: element, isLoading: isElementLoading } = useElement(
    ctx.elementId || root?.id
  );

  return (
    <Page
      isLoading={
        isLoading || isPreviousData || isRefetching || isElementLoading
      }
      Toolbar={StrategyToolbar}
    >
      <PageContainer width="1350px">
        <KPIGridArea>
          <InitiativesHeader header={t("initiatives.Initiatives")} />
          {data
            ? data
                .filter((el) => el.typename === "Initiative")
                .map((el) => (
                  <InitiativeCard
                    left_number_key="PLANNED_COMPLETION_prettyvalue"
                    left_number_title={t("initiatives.Planned Progress")}
                    right_number_key="VARIANCE_prettyvalue"
                    right_number_title={t("initiatives.Variance")}
                    cardTitle={t("initiatives.Actual Progress")}
                    period={ctx.period || ""}
                    key={`${el.id}-${ctx.period}`}
                    element={el}
                    translatedName={getTranslatedAttribute(el, "Name", ctx.language)}
                    onSelect={() => {
                      link({ page: "initiativedetails", meaId: el.id });
                    }}
                  />
                ))
            : null}
        </KPIGridArea>
      </PageContainer>
    </Page>
  );
};

export default Initiatives;
